// ⚠️  AUTO-GENERATED — DO NOT EDIT MANUALLY
// Generated: 2026-05-24T04:33:39.493Z
// Source: scripts/generate_search_index/generate.js

export const SEARCH_INDEX = [
  {
    title: "https://assets.greenscience.ca",
    path: "/",
    anchor: "assets-base-url",
    section: "Home — Hero",
    keywords: "https://assets.greenscience.ca",
    description: "",
  },
  {
    title: "https://assets.greenscience.ca",
    path: "/",
    anchor: "assets-base-url",
    section: "Home — Hero",
    keywords: "https://assets.greenscience.ca",
    description: "",
  },
  {
    title: "Home — Hero",
    path: "/",
    anchor: "",
    section: "Home — Hero",
    keywords: "pioneering patented technology diverts organic waste landfills explore how works",
    description: "Pioneering patented technology that diverts organic waste from landfills",
  },
  {
    title: "Home — Why GreenScience",
    path: "/",
    anchor: "",
    section: "Home — Why GreenScience",
    keywords: "core technology proprietary wireless telemetry heart operations unique web-enabled system developed collaboration toronto metropolitan university tmu based nasa nano-satellite monitors nine key scientific criteria real-time allowing 24-hour remote management without on-site personnel significantly reducing labour costs ensuring optimal machine efficiency monitored urban deployment urban-friendly decentralized unlike traditional composting anaerobic digestion facilities located far centres due odour noise concerns digester odourless noiseless pollution-free enables approach small-footprint near waste source eliminating high financial environmental transporting heavy water-saturated organic emissions pollution scalable scalability fully three tonnes per day upward allows greenscience deploy solutions ranging mid-sized large-scale regional supporting growing processing capacity demand increases minimum business model triple revenue stream while many competitors rely solely tipping fees product sales utilizes three-pronged collection sale high-value worm castings carbon offsets receiving tonne credit every matter processed streams credits market position economic resilience dependent government subsidies changes consumer habits provides cost-effective alternative landfilling increasingly restricted new legislation rising across north america subsidy dependency end superior produces often referred cadillac compost chemical fertilizers animal manure contain nutrients encased mucus membrane natural time-release preventing nutrient leaching improving crop yields soil health yield improvement additives why six reasons leads industry",
    description: "The technology is fully scalable from three tonnes per day and upward. This scalability allows GreenScience to deploy solutions ranging from mid-sized facilities to large-scale regional operations, supporting growing processing capacity as demand increases.",
  },
  {
    title: "https://assets.greenscience.ca",
    path: "/",
    anchor: "assets-base-url",
    section: "Home — The GS Digester",
    keywords: "https://assets.greenscience.ca",
    description: "",
  },
  {
    title: "https://assets.greenscience.ca",
    path: "/",
    anchor: "assets-base-url",
    section: "Home — The GS Digester",
    keywords: "https://assets.greenscience.ca",
    description: "",
  },
  {
    title: "Home — The GS Digester",
    path: "/",
    anchor: "",
    section: "Home — The GS Digester",
    keywords: "digester turn organic waste sustainable future greenscience proprietary urban-friendly recycling technology processes through scalable facilities mid-sized operations large regional operating odourlessly silently continuously convert high-value worm castings carbon credits see how works request demo diverted odour noise revenue streams patented",
    description: "Turn your organic waste into a sustainable future.",
  },
  {
    title: "https://assets.greenscience.ca",
    path: "/about",
    anchor: "assets-base-url",
    section: "About — Hero",
    keywords: "https://assets.greenscience.ca",
    description: "",
  },
  {
    title: "https://assets.greenscience.ca",
    path: "/about",
    anchor: "assets-base-url",
    section: "About — Hero",
    keywords: "https://assets.greenscience.ca",
    description: "",
  },
  {
    title: "About — Hero",
    path: "/about",
    anchor: "",
    section: "About — Hero",
    keywords: "built science driven purpose greenscience founded simple radical idea organic waste problem buried resource waiting unlocked",
    description: "GreenScience was founded on a simple but radical idea — that organic waste is not a problem to be buried, but a resource waiting to be unlocked.",
  },
  {
    title: "Chair",
    path: "/about",
    anchor: "john-ashbee",
    section: "About — Team",
    keywords: "john ashbee chair john ashbee, chair, has held management positions with several private and public companies, most recently, reworks inc. john has for a number of years been involved in promoting start-up ventures employing vermicasting technology. he is active in promoting corporate sustainability with a particular emphasis on supporting sustainable agricultural production. after a career that has taken him to the uk, australia, south africa, and the us, mr. ashbee brings extensive knowledge of soil amendments distribution, marketing, and the capital markets to greenscience. john graduated from ryerson university (now known as tmu) as a mechanical technologist with an aeronautic specialty. john extends his commitment to environmental awareness by lecturing at the high school level and universities. most recently a member of the city of toronto circular economy working group.",
    description: "John Ashbee, Chair, has held management positions with several private and public companies, most recently, reWorks Inc. John has for a number of years been involved in promoting start-up ventures employing vermicasting technology. He is active in promoting corporate sustainability with a particular emphasis on supporting sustainable agricultural production.",
  },
  {
    title: "President",
    path: "/about",
    anchor: "thomas-christiansen",
    section: "About — Team",
    keywords: "thomas christiansen president thomas christiansen is president of greenscience and leads the company's commercial strategy, business development, partnerships, customer acquisition, and operating growth. thomas has spent more than 20 years building revenue, leading teams, managing customers, and turning business opportunities into working commercial models. his background includes business-to-business sales, branch leadership, p&l ownership, sales management, service coordination, customer retention, margin performance, and operational oversight. that experience matters at greenscience because the company is not just selling an environmental idea. it is building an operating business around sustainable soil products, worm castings, organic waste diversion, and circular agriculture. that requires customers, partners, supply discipline, reliable execution, and a clear path to repeatable revenue. thomas brings a practical operator's mindset to that work. he has built and managed sales teams across regional and national markets, developed senior-level customer relationships, created strategic partnerships, and worked with structured expansion models including franchising and area development networks. his focus is on building greenscience into a credible commercial platform: one that can serve growers, producers, landscapers, municipalities, and organizations looking for better soil outcomes and better organic waste solutions. thomas is a graduate of seneca college, where he earned a three-year diploma in international business.",
    description: "Thomas Christiansen is President of GreenScience and leads the company's commercial strategy, business development, partnerships, customer acquisition, and operating growth.",
  },
  {
    title: "HonBSc, CFRE, CGE-RS — VP Corporate Sustainable Responsibility & Community Engagement",
    path: "/about",
    anchor: "d-darryl-r-peck",
    section: "About — Team",
    keywords: "d. darryl r. peck honbsc, cfre, cge-rs — vp corporate sustainable responsibility & community engagement darryl graduated from mcgill and guelph with a focus on resources planning and management. he has worked in the public, private and charitable sectors; work that has taken him to every province and territory in this country as well as to the united states, north korea, china, south america, europe and south africa. his work in the private and charitable sectors in the area of corporate social responsibility and philanthropy has resulted in the creation of a number of companies, 6 national ngos and the creation of csr and philanthropy programs at a number of successful companies. helping sustain and strengthen canada's civil society through successful partnerships between private enterprises and the country's not for profit sector has been a passion of mr. peck's throughout his career. he has appeared on radio and tv, and his work has been featured in national and international publications, magazines and newspapers.",
    description: "Darryl graduated from McGill and Guelph with a focus on Resources Planning and Management. He has worked in the public, private and charitable sectors; work that has taken him to every province and territory in this country as well as to the United States, North Korea, China, South America, Europe and South Africa.",
  },
  {
    title: "MBA, C.Mgr. — Corporate Finance & Business Development Advisor",
    path: "/about",
    anchor: "mark-barnes",
    section: "About — Team",
    keywords: "mark barnes mba, c.mgr. — corporate finance & business development advisor mark barnes provides core support to growth companies seeking to raise capital, build and strengthen management, develop and implement proactive growth strategies and improve business processes. a management consultant for over 17 years, with a quarter century of entrepreneurial experience, mr. barnes possesses strong strategic business planning skills with proven expertise in business development, marketing, financial modeling and project management. mark has an mba degree from the degroote school of business at mcmaster university, a diploma in business administration from wilfrid laurier university, and a ba in economics from the university of western ontario. as a chartered manager (c.mgr.), mark can be relied on to provide ethical, grounded and holistic managerial services and judgement.",
    description: "Mark Barnes provides core support to growth companies seeking to raise capital, build and strengthen management, develop and implement proactive growth strategies and improve business processes.",
  },
  {
    title: "MASc — VP of Technology",
    path: "/about",
    anchor: "kai-li",
    section: "About — Team",
    keywords: "kai li masc — vp of technology kai holds a master of applied science in chemical engineering from the university of waterloo. he brings over five years of experience collaborating with researchers and academic partners in national and private laboratories across materials science, air pollution control, wastewater treatment, and renewable energy. for the past 10 years, kai has provided strategic consultation and r&d leadership to the oil & gas, waste management, and chemical manufacturing sectors. he also has more than six years of experience in project management and product delivery, working closely with executive leadership teams to drive results. a results-focused and goal-oriented leader, kai combines technical expertise with strategic oversight to deliver high-impact solutions and advance organizational objectives.",
    description: "Kai holds a Master of Applied Science in Chemical Engineering from the University of Waterloo. He brings over five years of experience collaborating with researchers and academic partners in national and private laboratories across materials science, air pollution control, wastewater treatment, and renewable energy.",
  },
  {
    title: "Chair",
    path: "/about",
    anchor: "john-ashbee",
    section: "About — Team",
    keywords: "john ashbee chair john ashbee, chair, has held management positions with several private and public companies, most recently, reworks inc. john has for a number of years been involved in promoting start-up ventures employing vermicasting technology. he is active in promoting corporate sustainability with a particular emphasis on supporting sustainable agricultural production. after a career that has taken him to the uk, australia, south africa, and the us, mr. ashbee brings extensive knowledge of soil amendments distribution, marketing, and the capital markets to greenscience. john graduated from ryerson university (now known as tmu) as a mechanical technologist with an aeronautic specialty. john extends his commitment to environmental awareness by lecturing at the high school level and universities. most recently a member of the city of toronto circular economy working group.",
    description: "John Ashbee, Chair, has held management positions with several private and public companies, most recently, reWorks Inc. John has for a number of years been involved in promoting start-up ventures employing vermicasting technology. He is active in promoting corporate sustainability with a particular emphasis on supporting sustainable agricultural production.",
  },
  {
    title: "President",
    path: "/about",
    anchor: "thomas-christiansen",
    section: "About — Team",
    keywords: "thomas christiansen president thomas christiansen is president of greenscience and leads the company's commercial strategy, business development, partnerships, customer acquisition, and operating growth. thomas has spent more than 20 years building revenue, leading teams, managing customers, and turning business opportunities into working commercial models. his background includes business-to-business sales, branch leadership, p&l ownership, sales management, service coordination, customer retention, margin performance, and operational oversight. that experience matters at greenscience because the company is not just selling an environmental idea. it is building an operating business around sustainable soil products, worm castings, organic waste diversion, and circular agriculture. that requires customers, partners, supply discipline, reliable execution, and a clear path to repeatable revenue. thomas brings a practical operator's mindset to that work. he has built and managed sales teams across regional and national markets, developed senior-level customer relationships, created strategic partnerships, and worked with structured expansion models including franchising and area development networks. his focus is on building greenscience into a credible commercial platform: one that can serve growers, producers, landscapers, municipalities, and organizations looking for better soil outcomes and better organic waste solutions. thomas is a graduate of seneca college, where he earned a three-year diploma in international business.",
    description: "Thomas Christiansen is President of GreenScience and leads the company's commercial strategy, business development, partnerships, customer acquisition, and operating growth.",
  },
  {
    title: "HonBSc, CFRE, CGE-RS — VP Corporate Sustainable Responsibility & Community Engagement",
    path: "/about",
    anchor: "d-darryl-r-peck",
    section: "About — Team",
    keywords: "d. darryl r. peck honbsc, cfre, cge-rs — vp corporate sustainable responsibility & community engagement darryl graduated from mcgill and guelph with a focus on resources planning and management. he has worked in the public, private and charitable sectors; work that has taken him to every province and territory in this country as well as to the united states, north korea, china, south america, europe and south africa. his work in the private and charitable sectors in the area of corporate social responsibility and philanthropy has resulted in the creation of a number of companies, 6 national ngos and the creation of csr and philanthropy programs at a number of successful companies. helping sustain and strengthen canada's civil society through successful partnerships between private enterprises and the country's not for profit sector has been a passion of mr. peck's throughout his career. he has appeared on radio and tv, and his work has been featured in national and international publications, magazines and newspapers.",
    description: "Darryl graduated from McGill and Guelph with a focus on Resources Planning and Management. He has worked in the public, private and charitable sectors; work that has taken him to every province and territory in this country as well as to the United States, North Korea, China, South America, Europe and South Africa.",
  },
  {
    title: "MBA, C.Mgr. — Corporate Finance & Business Development Advisor",
    path: "/about",
    anchor: "mark-barnes",
    section: "About — Team",
    keywords: "mark barnes mba, c.mgr. — corporate finance & business development advisor mark barnes provides core support to growth companies seeking to raise capital, build and strengthen management, develop and implement proactive growth strategies and improve business processes. a management consultant for over 17 years, with a quarter century of entrepreneurial experience, mr. barnes possesses strong strategic business planning skills with proven expertise in business development, marketing, financial modeling and project management. mark has an mba degree from the degroote school of business at mcmaster university, a diploma in business administration from wilfrid laurier university, and a ba in economics from the university of western ontario. as a chartered manager (c.mgr.), mark can be relied on to provide ethical, grounded and holistic managerial services and judgement.",
    description: "Mark Barnes provides core support to growth companies seeking to raise capital, build and strengthen management, develop and implement proactive growth strategies and improve business processes.",
  },
  {
    title: "MASc — VP of Technology",
    path: "/about",
    anchor: "kai-li",
    section: "About — Team",
    keywords: "kai li masc — vp of technology kai holds a master of applied science in chemical engineering from the university of waterloo. he brings over five years of experience collaborating with researchers and academic partners in national and private laboratories across materials science, air pollution control, wastewater treatment, and renewable energy. for the past 10 years, kai has provided strategic consultation and r&d leadership to the oil & gas, waste management, and chemical manufacturing sectors. he also has more than six years of experience in project management and product delivery, working closely with executive leadership teams to drive results. a results-focused and goal-oriented leader, kai combines technical expertise with strategic oversight to deliver high-impact solutions and advance organizational objectives.",
    description: "Kai holds a Master of Applied Science in Chemical Engineering from the University of Waterloo. He brings over five years of experience collaborating with researchers and academic partners in national and private laboratories across materials science, air pollution control, wastewater treatment, and renewable energy.",
  },
  {
    title: "The Hon. Senator Donna Dasko PhD — Distinguished Fellow, Munk School of Global Affairs & Public Policy, University of Toronto",
    path: "/about",
    anchor: "senator-donna-dasko",
    section: "About — Team",
    keywords: "senator donna dasko the hon. senator donna dasko phd — distinguished fellow, munk school of global affairs & public policy, university of toronto",
    description: "",
  },
  {
    title: "BSc PhD FRSC FRGS — Professor Emeritus, Trent University",
    path: "/about",
    anchor: "dr-tom-c-hutchinson",
    section: "About — Team",
    keywords: "dr. tom c. hutchinson bsc phd frsc frgs — professor emeritus, trent university",
    description: "",
  },
  {
    title: "Professor of Aerospace, Director of Artificial Intelligence at TMU, and Canada Research Chair in Space Systems",
    path: "/about",
    anchor: "dr-krishna-kumar",
    section: "About — Team",
    keywords: "dr. krishna kumar professor of aerospace, director of artificial intelligence at tmu, and canada research chair in space systems",
    description: "",
  },
  {
    title: "PhD Soil Fertility & Nutrient Management — Researcher, Agriculture and Agri-Food Canada, Summerland Research Centre",
    path: "/about",
    anchor: "dr-mehdi-sharifi",
    section: "About — Team",
    keywords: "dr. mehdi sharifi phd soil fertility & nutrient management — researcher, agriculture and agri-food canada, summerland research centre",
    description: "",
  },
  {
    title: "Science & Techology Advisor",
    path: "/about",
    anchor: "arunav-misra-meng",
    section: "About — Team",
    keywords: "arunav misra, meng science & techology advisor",
    description: "",
  },
  {
    title: "The Hon. Senator Donna Dasko PhD — Distinguished Fellow, Munk School of Global Affairs & Public Policy, University of Toronto",
    path: "/about",
    anchor: "senator-donna-dasko",
    section: "About — Team",
    keywords: "senator donna dasko the hon. senator donna dasko phd — distinguished fellow, munk school of global affairs & public policy, university of toronto",
    description: "",
  },
  {
    title: "BSc PhD FRSC FRGS — Professor Emeritus, Trent University",
    path: "/about",
    anchor: "dr-tom-c-hutchinson",
    section: "About — Team",
    keywords: "dr. tom c. hutchinson bsc phd frsc frgs — professor emeritus, trent university",
    description: "",
  },
  {
    title: "Professor of Aerospace, Director of Artificial Intelligence at TMU, and Canada Research Chair in Space Systems",
    path: "/about",
    anchor: "dr-krishna-kumar",
    section: "About — Team",
    keywords: "dr. krishna kumar professor of aerospace, director of artificial intelligence at tmu, and canada research chair in space systems",
    description: "",
  },
  {
    title: "PhD Soil Fertility & Nutrient Management — Researcher, Agriculture and Agri-Food Canada, Summerland Research Centre",
    path: "/about",
    anchor: "dr-mehdi-sharifi",
    section: "About — Team",
    keywords: "dr. mehdi sharifi phd soil fertility & nutrient management — researcher, agriculture and agri-food canada, summerland research centre",
    description: "",
  },
  {
    title: "Science & Techology Advisor",
    path: "/about",
    anchor: "arunav-misra-meng",
    section: "About — Team",
    keywords: "arunav misra, meng science & techology advisor",
    description: "",
  },
  {
    title: "About — Team",
    path: "/about",
    anchor: "",
    section: "About — Team",
    keywords: "view profile linkedin advisory board guided world-class expertise science policy sustainability people behind greenscience passionate driven innovation",
    description: "Guided by world-class expertise in science, policy, and sustainability.",
  },
  {
    title: "About — Research",
    path: "/about",
    anchor: "",
    section: "About — Research",
    keywords: "toronto metropolitan university aerospace engineering department collaboration tmu brings nasa-derived sensor telemetry technology organic waste processing space enabling real-time remote monitoring sets digester apart every competing system agriculture agri-food canada summerland research development centre working okanagan valley validate agronomic performance worm castings ensuring batch meets highest standards soil fertility nutrient availability long-term health partnerships grounded academic excellence validated leading canadian institutions spanning science permaculture industrial design",
    description: "Our collaboration with TMU's Aerospace Engineering Department brings NASA-derived sensor and telemetry technology into the organic waste processing space — enabling the real-time, 24/7 remote monitoring that sets the GS Digester apart from every competing system.",
  },
  {
    title: "About — Innovation",
    path: "/about",
    anchor: "",
    section: "About — Innovation",
    keywords: "worm castings produced per tonne organic waste processed critical operational parameters tracked real time certified carbon credit generated resource greenscience technology represents world-first advancement how millions tonnes daily canada managed rather viewing disposal challenge company treats underutilized natural highly efficient biological process system creates controlled environment cluster earthworms naturally through every produces approximately 180 kilograms premium valuable soil amendment harvested generation addition producing nutrient-rich products generate credits creating additional environmental economic benefit tradable offsets advanced remote monitoring unit continuously tracks using array precision sensors monitored remotely mobile devices allowing operators identify address issues instantly whenever detect irregularities digester doesn just efficiently reframes become",
    description: "Of worm castings produced per tonne of organic waste processed",
  },
  {
    title: "About — Community",
    path: "/about",
    anchor: "",
    section: "About — Community",
    keywords: "northern food security supporting arviat green igloo project greenscience donated 000-pound tote premium worm castings assist greenhouse operations inuit community through partnership toronto metropolitan university initiative directly supports sovereignty canada most remote communities local bank contributions high-value vegetables grown organic waste processing facility banks transforms outputs process immediate tangible nutrition closing loop indigenous chippewas thames first nation worked support efforts diversify income streams potential establishment operation creating employment long-term economic resilience engagement rooted serve recognizes environmental progress wellbeing inseparable particularly committed contributing initiatives benefit nations",
    description: "Supporting the Arviat Green Igloo Project",
  },
  {
    title: "2024",
    path: "/about",
    anchor: "technology-validated",
    section: "About — Sustainability Roadmap",
    keywords: "2024 technology validated patented process proven at pilot scale.",
    description: "",
  },
  {
    title: "2026",
    path: "/about",
    anchor: "first-commercial-deployment",
    section: "About — Sustainability Roadmap",
    keywords: "2026 first commercial deployment operational facility processing organic waste.",
    description: "",
  },
  {
    title: "2028",
    path: "/about",
    anchor: "scale-nationally",
    section: "About — Sustainability Roadmap",
    keywords: "2028 scale nationally multiple facilities across canada.",
    description: "",
  },
  {
    title: "2035",
    path: "/about",
    anchor: "1m-tonnes-diverted",
    section: "About — Sustainability Roadmap",
    keywords: "2035 500,000 tonnes diverted annually diverts 500,000 tonnes of organic waste from landfills annually.",
    description: "",
  },
  {
    title: "About — Sustainability Roadmap",
    path: "/about",
    anchor: "",
    section: "About — Sustainability Roadmap",
    keywords: "sustainability roadmap clear path diverting million tonnes organic waste landfills 2030 technology validated patented process proven pilot scale first commercial deployment operational facility processing nationally multiple facilities across canada 500 000 diverted annually diverts",
    description: "A clear path to diverting 1 million tonnes of organic waste from landfills by 2030.",
  },
  {
    title: "https://assets.greenscience.ca",
    path: "/solution",
    anchor: "assets-base-url",
    section: "Solution — Video",
    keywords: "https://assets.greenscience.ca",
    description: "",
  },
  {
    title: "https://assets.greenscience.ca",
    path: "/solution",
    anchor: "assets-base-url",
    section: "Solution — Video",
    keywords: "https://assets.greenscience.ca",
    description: "",
  },
  {
    title: "Solution — Video",
    path: "/solution",
    anchor: "",
    section: "Solution — Video",
    keywords: "greenscience waste transformation process see action organic valuable resources patented transforms reducing landfill greenhouse gas emissions",
    description: "GreenScience waste transformation process",
  },
  {
    title: "Solution — The GreenScience Cycle",
    path: "/solution",
    anchor: "",
    section: "Solution — The GreenScience Cycle",
    keywords: "greenscience cycle transforming urban organic waste premium bio-fertilizer closed-loop seven-step process eliminates landfill produces zero odour generates soil product within minimal footprint seven steps receiving preparation through vermistabilization final processing",
    description: "A closed-loop, seven-step process that eliminates landfill waste, produces zero odour, and generates a premium soil product — all within a minimal urban footprint.",
  },
  {
    title: "Impact — Hero",
    path: "/impact",
    anchor: "",
    section: "Impact — Hero",
    keywords: "landfill diversion rate every tonne processed stays permanently reduction ghg emissions versus conventional organic waste disposal methods target tonnes diverted annually growing greenscience scales across north america impact turning win everyone doesn just manage closes loop becomes measurable environmental social economic benefit",
    description: "Every tonne processed stays out of landfill, permanently.",
  },
  {
    title: "Impact — Ten Wins, No Losses",
    path: "/impact",
    anchor: "",
    section: "Impact — Ten Wins, No Losses",
    keywords: "ten wins losses greenscience soil revolution process doesn just solve problem creates distinct across environmental stewardship community infrastructure social economic impact infographic showing benefits",
    description: "Our process doesn't just solve one problem — it creates ten distinct wins across environmental stewardship, community infrastructure, and social & economic impact.",
  },
  {
    title: "Waste Diverted Annually",
    path: "/impact",
    anchor: "waste-diverted-annually",
    section: "Impact — Environmental Stats",
    keywords: "waste diverted annually",
    description: "",
  },
  {
    title: "Reduction in GHG Emissions",
    path: "/impact",
    anchor: "reduction-in-ghg-emissions",
    section: "Impact — Environmental Stats",
    keywords: "reduction in ghg emissions",
    description: "",
  },
  {
    title: "Landfill Diversion Rate",
    path: "/impact",
    anchor: "landfill-diversion-rate",
    section: "Impact — Environmental Stats",
    keywords: "landfill diversion rate",
    description: "",
  },
  {
    title: "Waste Diverted Annually",
    path: "/impact",
    anchor: "waste-diverted-annually",
    section: "Impact — Environmental Stats",
    keywords: "waste diverted annually",
    description: "",
  },
  {
    title: "Reduction in GHG Emissions",
    path: "/impact",
    anchor: "reduction-in-ghg-emissions",
    section: "Impact — Environmental Stats",
    keywords: "reduction in ghg emissions",
    description: "",
  },
  {
    title: "Landfill Diversion Rate",
    path: "/impact",
    anchor: "landfill-diversion-rate",
    section: "Impact — Environmental Stats",
    keywords: "landfill diversion rate",
    description: "",
  },
  {
    title: "Impact — Environmental Stats",
    path: "/impact",
    anchor: "",
    section: "Impact — Environmental Stats",
    keywords: "numbers measurable environmental results every facility operate produces verifiable auditable outcomes estimates",
    description: "Every facility we operate produces verifiable, auditable outcomes — not estimates.",
  },
  {
    title: "Global Organic Waste Management Market by 2034",
    path: "/impact",
    anchor: "global-organic-waste-management-market-by-2034",
    section: "Impact — Market Opportunity",
    keywords: "global organic waste management market by 2034",
    description: "",
  },
  {
    title: "Annual Market Growth Rate (CAGR) through 2034",
    path: "/impact",
    anchor: "annual-market-growth-rate-cagr-through-2034",
    section: "Impact — Market Opportunity",
    keywords: "annual market growth rate (cagr) through 2034",
    description: "",
  },
  {
    title: "Canada's Organic Recycling Market Projected by 2028",
    path: "/impact",
    anchor: "canada-s-organic-recycling-market-projected-by-2028",
    section: "Impact — Market Opportunity",
    keywords: "canada's organic recycling market projected by 2028",
    description: "",
  },
  {
    title: "Global Organic Waste Management Market by 2034",
    path: "/impact",
    anchor: "global-organic-waste-management-market-by-2034",
    section: "Impact — Market Opportunity",
    keywords: "global organic waste management market by 2034",
    description: "",
  },
  {
    title: "Annual Market Growth Rate (CAGR) through 2034",
    path: "/impact",
    anchor: "annual-market-growth-rate-cagr-through-2034",
    section: "Impact — Market Opportunity",
    keywords: "annual market growth rate (cagr) through 2034",
    description: "",
  },
  {
    title: "Canada's Organic Recycling Market Projected by 2028",
    path: "/impact",
    anchor: "canada-s-organic-recycling-market-projected-by-2028",
    section: "Impact — Market Opportunity",
    keywords: "canada's organic recycling market projected by 2028",
    description: "",
  },
  {
    title: "Impact — Market Opportunity",
    path: "/impact",
    anchor: "",
    section: "Impact — Market Opportunity",
    keywords: "market opportunity growing global organic waste management sector expanding rapidly driven regulation esg mandates economics resource recovery",
    description: "The organic waste management sector is expanding rapidly, driven by regulation, ESG mandates, and the economics of resource recovery.",
  },
  {
    title: "Opportunity — Hero",
    path: "/opportunity",
    anchor: "",
    section: "Opportunity — Hero",
    keywords: "organic waste market 2034 growing 61b 2024 cagr driven landfill bans circular economy mandates fertilizer doubling 71b 2025 fuelled soil health needs regulatory pressure opportunity two markets solution greenscience sits intersection rapidly expanding management while others choose process captures both simultaneously creating uniquely resilient high-growth business model",
    description: "Growing from $17.61B in 2024 at a 7.91% CAGR.",
  },
  {
    title: "Select...",
    path: "/contact",
    anchor: "contact-type",
    section: "Contact — Get in Touch",
    keywords: "select...",
    description: "",
  },
  {
    title: "Request for Info",
    path: "/contact",
    anchor: "request-for-info",
    section: "Contact — Get in Touch",
    keywords: "request for info",
    description: "",
  },
  {
    title: "Become a Partner",
    path: "/contact",
    anchor: "become-a-partner",
    section: "Contact — Get in Touch",
    keywords: "become a partner",
    description: "",
  },
  {
    title: "Other",
    path: "/contact",
    anchor: "other",
    section: "Contact — Get in Touch",
    keywords: "other",
    description: "",
  },
  {
    title: "Request for Info",
    path: "/contact",
    anchor: "request-for-info",
    section: "Contact — Get in Touch",
    keywords: "request for info",
    description: "",
  },
  {
    title: "Become a Partner",
    path: "/contact",
    anchor: "become-a-partner",
    section: "Contact — Get in Touch",
    keywords: "become a partner",
    description: "",
  },
  {
    title: "Other",
    path: "/contact",
    anchor: "other",
    section: "Contact — Get in Touch",
    keywords: "other",
    description: "",
  },
  {
    title: "Contact — Get in Touch",
    path: "/contact",
    anchor: "",
    section: "Contact — Get in Touch",
    keywords: "thank received message get back shortly send another touch let talk whether looking information exploring partnership want stay updated progress love hear request info learn technology how work become partner explore collaboration opportunities greenscience connect linkedin 800 513-8098 first name last email company inquiry type tell help",
    description: "We've received your message and will get back to you shortly.",
  },
  {
    title: "Contact — Hub Spot Meetings",
    path: "/contact",
    anchor: "",
    section: "Contact — Hub Spot Meetings",
    keywords: "book meeting schedule call ready talk time directly team",
    description: "Ready to talk? Book a time directly with our team.",
  },
  {
    title: "Terms Of Use",
    path: "/terms-of-use",
    anchor: "",
    section: "",
    keywords: "terms use please read carefully before using greenscience website accessing site agree bound acceptance located accept privacy policy technology company developing ai-powered solutions help businesses measure manage reduce environmental impact information provided general informational purposes only intellectual property content including limited text graphics logos icons images audio clips software inc protected applicable canadian international laws may reproduce distribute publicly display any without prior written consent modify create derivative works based trademarks branding explicit permission scrape crawl systematically extract data permitted access lawful personal non-commercial specifically browse available share links pages contact through official channels download materials explicitly made prohibited conduct violate local provincial national law transmit unsolicited unauthorised advertising promotional material attempt gain part its systems interfere disrupt integrity performance upload viruses malicious code impersonate person entity misrepresent affiliation collect harvest users disclaimer warranties basis kind either express implied warrant uninterrupted timely secure error-free results obtained accurate reliable errors corrected limitation liability fullest extent directors officers employees agents shall liable indirect incidental special consequential punitive damages arising inability third-party contain websites convenience control over sites accepts responsibility loss damage arise also governed incorporated reference review understand practices governing construed accordance province ontario federal canada therein regard conflict principles changes reserves right time effective immediately upon posting continued following constitutes revised encourage periodically questions toronto form last updated",
    description: "Please read these Terms of Use carefully before using the GreenScience website. By accessing or using our site, you agree to be bound by these terms.",
  },
  {
    title: "Privacy Policy",
    path: "/privacy-policy",
    anchor: "",
    section: "",
    keywords: "privacy policy greenscience committed protecting explains how collect use disclose safeguard information visit website who inc technology company headquartered toronto ontario canada develop ai-powered environmental intelligence solutions businesses applies collected through provide directly voluntarily fill contact form name email address message subscribe newsletter updates request product demonstration communicate means automatically site may certain technical including approximate geographic location browser type version operating system pages visited time spent page referring urls device identifiers cookies tracking technologies similar enhance experience small data files stored essential required function properly analytics help understand visitors interact preference remember settings preferences control note disabling affect functionality respond enquiries customer support send requested products services improve optimise user analyse usage patterns trends comply legal obligations protect against fraudulent unlawful activity periodic communications consent basis processing applicable under canadian law pipeda relevant legislation process personal based given explicit legitimate interests operate business obligation laws contractual necessity fulfil contract share sell trade rent third parties service providers trusted third-party vendors assist conducting hosting subject confidentiality authorities court order governmental authority transfers connection merger acquisition sale assets appropriate notice retention retain only long necessary purposes outlined unless longer period permitted submissions typically retained months security implement organisational measures unauthorised access alteration disclosure destruction include encryption secure servers controls however method transmission over internet electronic storage 100 while strive commercially acceptable cannot guarantee absolute rights depending following regarding copy hold correction inaccurate incomplete deletion withdrawal withdraw unsubscribe marketing any lodge complaint supervisory exercise please within days international transferred processed countries transfer internationally ensure safeguards place accordance children directed individuals age knowingly believe inadvertently child immediately take steps delete such links contain websites apply sites encourage review policies changes update notify significant posting new updated last date periodically questions concerns requests practices officer",
    description: "GreenScience is committed to protecting your privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website.",
  }
];
